module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("This time he didn’t have to fight his way past Hoyle, the manager. Instead, he was admitted immediately to Sam Pope’s office.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The big, gray-haired man was behind his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sit down,” he said. “Now. What’s the rush about? What’s happened to Howard?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What happened to you?” Gray asked. “You agreed to cooperate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That was before all this trouble. I asked you what’s happened to Howard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What always happens. The patient gets worse before he gets better. It’s inevitable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope shook his head slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It sounds like an easy out, Mr. Gray. Those kids are important to me—Mary and Howard. I’ve no children of my own. And I’m almost old enough to be their father. All right—Howard’s sick. He’s got to be cured. We’re in agreement on that, aren’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then I want to know what’s wrong. I want to know, so I can help them. If it’s money, I’ve got plenty. But I want to know what I’m spending it for. I don’t know what Howard’s told you about me….” He paused.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not that I give a damn. My life’s an open book.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “Can you read it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A lot of that book is printed in invisible ink,” Gray said. “That’s the basis of psychoanalytic theory, Mr. Pope. It’s the invisible ink that causes trouble. And that’s in everybody’s book. Yours and mine, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not a patient,” Pope said, his voice annoyed. “Are you trying to tell me Howard’s not sick?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He has an emotional illness,” Gray said. “In fact, you were the first one to recommend psychotherapy to him, weren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A sanitarium,” Pope said. “At least—I don’t want to be critical, Mr. Gray, but if my doctor treated me for something and I got worse, I’d change doctors. Psychoanalysis isn’t any different, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not a bit,” Gray said. “There’s only one question. How would you know whether you were getting worse or better?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hell, isn’t that obvious?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not always. Suppose, twenty years ago, you were treated by a physician, and as a result you developed a high fever. Would you be worse or better?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What’s the gimmick?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The old fever treatment for syphilis worked pretty well, until antibiotics were improved. High temperature killed the bugs. But unless you knew what to expect, you’d certainly think you were getting worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope said, “In other words, you want people to take you on faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Competence can’t be taken on faith,” he said. “Your own doctor—or Doctor Bronson—can tell you where the local psychoanalytic institute is. You can find out there whether an analyst has been adequately trained.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That still wouldn’t satisfy me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The relatives of a patient—and the patient—have a right to ask the analyst any questions they like about his qualifications. They should, if they’re doubtful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And he can always say he can’t answer because of professional ethics.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That applies to the patient’s right of privacy, not the analyst’s. Let me ask you something. Is there anyone in medicine or psychotherapy whose judgment you do trust?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure,” Pope said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then you can ask for a consultation. Usually the family physician and another psychoanalyst are called in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“To examine the patient?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It isn’t always necessary,” Gray said. “In this case, since I gather you’re the one who’s dissatisfied, I suggest that you go ahead and investigate. I’d prefer it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a pause. Pope idly slapped his fist into his palm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You know what happened night before last?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know some of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And you still say Howard’s getting better?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That doesn’t make sense,” Pope said flatly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“From one viewpoint, as I say, the patient does get worse before he gets better. It’s the job of the therapist to modify the disturbing influence of the invisible writing as it comes to light.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope considered.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray went on. “Everybody tries to shield himself from whatever’s neurotic in his own nature. You do that; so do I.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hell, I’m not neurotic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “Is there anything you try to avoid thinking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a long pause. Pope glanced at Gray, looked away, and stared at the desk before him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s damned nonsense,” he said with sudden anger.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, I can’t read your mind,” Gray said, “but it doesn’t take a psychoanalyst to guess that you did think of something painful just then. That’s what’s happening to Howard Dunne now, but it’s a good deal more difficult for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“There’s all the difference in the world!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You became angry, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I didn’t knock you down, the way Howard did with Farragut. Served him right, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How angry does a man have to be before he knocks somebody down? Haven’t you ever done it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure,” Pope said. “But that’s—” He paused.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After a while Gray said, “The family is usually a focal point in a neurosis. Symptoms may be stirred up there pretty easily. What the family finds it hardest to understand is the change in the patient. I’d prefer that you checked up. I’ve suggested some ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope said, “All right. I’ll do exactly that. But just what do you want from me? Doctor Bronson wasn’t too clear.” He hesitated, and suddenly relaxed into a grin. “Maybe I didn’t give him much time to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said slowly, “A psychotherapist shouldn’t interfere in his patient’s life. That’s essential. I can’t tell you what to do, Mr. Pope. I did want you to know more about what psychoanalytic treatment involves, and how to satisfy yourself that Howard is being competently treated.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray went on. “There’s one thing. I wouldn’t bring it up at all, but before I accepted Howard as a patient, you told me that you’d cooperate. Now I realize that you’re anxious. But my responsibility to my patient comes first. I feel that it would be unwise for you to move into the Dunne house. I’d like your assurance that you won’t.” Gray looked steadily at the other man. “At least, until you’ve satisfied yourself about me. Let’s say till after a consultation has been held.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope said slowly, “What about Mary? I’m really worried about her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You might talk to her about that. After all, she could take a vacation herself for a few weeks. Wouldn’t that help?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not a bad idea,” Pope said. “I suppose … yes, Mary could do that. All right, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “You’ll postpone any decision about moving in until after a consultation?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pope nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fair enough,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray hesitated. There were other questions he badly wanted to ask—about the dead Eleanor Pope, for example. But now was not the time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Later. But—how much time was there?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The next interview with Dunne might give him that answer, he thought. It would probably be the most difficult session so far.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb51194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/16_chapter12.vue
// module id = 108
// module chunks = 0